export default __webpack_public_path__ + "static/media/art_01.d7965be3.jpg";